module.exports = __webpack_public_path__ + "static/media/shervinshahryari.74138295.png";